import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_HIGH_AMOUNT_CONFIRMATION_MODAL = createFcmConfig('high_amount_confirmation_modal', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
